import WorkoutPages from "@/components/WorkoutProfiles/WorkoutPages/WorkoutPages";

const WorkoutPagesPage = () => {
  return <WorkoutPages elevation={true} />;
};

export default WorkoutPagesPage;
